// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { push } from 'react-router-redux';

import InfoIcon from '../../../../common/svgs/InfoIcon';
import CloseX from '../../../../common/svgs/CloseX';

export default class JobRequestAlert extends Component {

  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    alert: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    selected: PropTypes.bool,
  }

  go(path) {
    return (e) => {
      this.props.dispatch(push(path));
    };
  }

  render() {

      const alert = this.props.alert;

      return(

        <div className={`job-request-alert ${this.props.selected === alert.id ? '' : 'inactive'}`} key={alert.id} data-id={`alert-${alert.id}`} onClick={() => this.props.onSelect(alert)}>
          <div className='left-side'>
            <InfoIcon color={alert.isRead ? '#777777' : ''} />
            <div className='job-request-alert-message'>
              { alert.alertData.prefixMessage }&nbsp;
              <span className='notification-link' onClick={this.go(`/admin/contacts/${alert.alertData.target}/details`)}>{ alert.alertData.name }</span>,&nbsp;
              { alert.alertData.title }, <span className='notification-link' onClick={this.go(`/admin/companies/${alert.alertData.companyId}/details`)}>{ alert.alertData.companyName }</span>
              { alert.alertData.companyStatus === 4 && alert.alertData.suffixMessageActiveAccount }
              { (alert.alertData.companyStatus === 1  || alert.alertData.companyStatus === 2) && alert.alertData.suffixMessageProspect }
            </div>
          </div>
          <CloseX className='dismiss-button' onClick={(e) => this.props.onClose(e, alert.id)} />
        </div>

      );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Alerts/JobRequestAlert/index.js